import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01190127"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logistics-track-dialog" }
const _hoisted_2 = {
  key: 0,
  class: "logistics-header"
}
const _hoisted_3 = { class: "header-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "物流公司：", -1))
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "header-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "快递单号：", -1))
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "header-row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "车牌号：", -1))
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "header-row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "司机：", -1))
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "header-row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "手机号：", -1))
const _hoisted_17 = { class: "value" }
const _hoisted_18 = {
  key: 1,
  class: "logistics-timeline"
}
const _hoisted_19 = { class: "timeline-dot" }
const _hoisted_20 = {
  key: 0,
  class: "line"
}
const _hoisted_21 = { class: "timeline-content" }
const _hoisted_22 = { class: "status-name" }
const _hoisted_23 = { class: "track-time" }
const _hoisted_24 = {
  key: 0,
  class: "track-address"
}
const _hoisted_25 = {
  key: 0,
  class: "track-extra"
}
const _hoisted_26 = {
  key: 1,
  class: "track-extra"
}
const _hoisted_27 = {
  key: 2,
  class: "track-extra"
}
const _hoisted_28 = {
  key: 2,
  class: "no-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.trackData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.trackData.isSelfDelivery)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.trackData.logisticsCompany || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.trackData.waybillNo || '-'), 1),
                  (_ctx.trackData.waybillNo)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "copy-btn",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyText(_ctx.trackData.waybillNo)))
                      }, "复制"))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.trackData.licensePlate || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.trackData.driverName || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.trackData.driverPhone || '-'), 1)
                ])
              ], 64))
        ]))
      : _createCommentVNode("", true),
    (_ctx.trackList && _ctx.trackList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trackList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["timeline-item", { active: index === 0 }])
            }, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", {
                  class: _normalizeClass(["dot", { 'dot-active': index === 0 }])
                }, null, 2),
                (index < _ctx.trackList.length - 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, _toDisplayString(item.logisticsStatusName), 1),
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.formatTime(item.trackTime)), 1),
                (_ctx.getAddress(item))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.getAddress(item)), 1))
                  : _createCommentVNode("", true),
                (_ctx.trackData && _ctx.trackData.isSelfDelivery)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (item.numberPlate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, "车牌：" + _toDisplayString(item.numberPlate), 1))
                        : _createCommentVNode("", true),
                      (item.driver)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, "司机：" + _toDisplayString(item.driver), 1))
                        : _createCommentVNode("", true),
                      (item.courierPhone)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, "电话：" + _toDisplayString(item.courierPhone), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_28, "暂无物流轨迹"))
  ]))
}